import { ObjectType, Field, InputType, Int, ID, registerEnumType } from 'type-graphql'
import { ObjectRef } from '@things-factory/shell'
import { PartnerSetting } from './partner-setting'

@InputType()
export class NewPartnerSetting {
  @Field(type => ObjectRef)
  partnerDomain: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  setting: ObjectRef

  @Field({ nullable: true })
  value?: string
}

@InputType()
export class PartnerSettingPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field(type => ObjectRef, { nullable: true })
  partnerDomain: ObjectRef

  @Field(type => ObjectRef, { nullable: true })
  setting: ObjectRef

  @Field({ nullable: true })
  value?: string

  @Field()
  cuFlag: string
}

@ObjectType()
export class PartnerSettingList {
  @Field(type => [PartnerSetting])
  items: PartnerSetting[]

  @Field(type => Int)
  total: number
}
